// Chuyển kết quả thất bại của một call trong http.js thành câu tiếng Việt hiện
// cho user. Callback của http.js nhận hai dạng khác nhau: object body khi server
// có trả lời, hoặc thẳng object Error khi fetch throw — nên phải phân biệt.

export const MSG_NETWORK =
  "Không kết nối được máy chủ. Kiểm tra mạng rồi thử lại.";
export const MSG_FORBIDDEN =
  "Bạn không sửa được booking này — chỉ người tạo hoặc admin/operator mới sửa được.";
export const MSG_FALLBACK = "Có lỗi xảy ra, thử lại sau.";

export function getApiErrorMessage(res) {
  // Phải xét Error trước: nó không có .status nên nếu đọc .status trước thì lỗi
  // mất mạng sẽ rơi xuống nhánh chung và giấu mất nguyên nhân thật.
  if (res instanceof Error) return MSG_NETWORK;
  if (res == null) return MSG_FALLBACK;

  if (res.status === 403) return MSG_FORBIDDEN;

  if (typeof res.message === "string" && res.message !== "") {
    return res.message;
  }

  return MSG_FALLBACK;
}
